// extracted by mini-css-extract-plugin
export default {"syncButton":"Settings_syncButton__5w46W"};